/* eslint-disable react/no-multi-comp */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/jsx-max-props-per-line */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { makeStyles } from '@material-ui/styles';
import { TableCell, Grid } from '@material-ui/core';
import { Table, CustomFilter } from '../../components';
import * as selectorsAuth from '../../store/auth/reducer';
import * as actionsOlerite from '../../store/olerite/actions';
import Formulario from './Formulario';
import * as selectorsModuleConfiguration from '../../store/moduleConfiguration/reducer';
import { OLERITE } from 'constants/modules';
import FormularioEdicao from './FormularioEdicao';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
}));

const defaultFilter = (moduleConfigurations, authData) => ({
  usuarioId : !hasPermission(moduleConfigurations, authData) ? [authData.id] : [],
});

const hasPermission = (moduleConfigurations, authData) => moduleConfigurations?.some(u => u.codigo === OLERITE && u.userId === authData.id);

const Olerite = ({ authData, moduleConfigurations, deleteOlerite }) => {
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdicao, setOpenEdicao] = useState(false);
  const [id, setId] = useState(null);
  const [localFilter, setLocalFilter] = useState(defaultFilter(moduleConfigurations, authData));
  const [reload, setReload] = useState(false);

  const classes = useStyles();
  const adminPermission = hasPermission(moduleConfigurations, authData);

  const renderRows = d => (
    <>
      <TableCell>{d.mesReferenciaValue}</TableCell>
      <TableCell>{d.tipo}</TableCell>
      <TableCell>{d.usuarioNome}</TableCell>
      <TableCell>{d.criadoPorNome}</TableCell>
      <TableCell>{d.dataInclusaoValue}</TableCell>
    </>
  );

  const onEdit = id => {
    setId(id);
    setOpenEdicao(true);
  };

  const onAdd = () => {
    setId(null);
    setOpenAdd(true);
  };

  const onClose = (save) => {
    setId(null);
    setOpenEdicao(false);
    setOpenAdd(false);
    if (save) {
      setReload(!reload);
    }
  };

  const onDelete = (id) => deleteOlerite(id, () => setReload(!reload));

  return (
    <Grid container>
      <Grid item xs={12}>
        <CustomFilter
          onFilter={filterData => setLocalFilter(filterData)}
          fields={[
            { field: 'useMesReferencia', md: 3, xs: 6 },
            { field: 'useSelectOption', md: 3, xs: 6, key: 'tipo', label: 'Tipo', options: [{ id: 'HOLERITE', nome: 'Holerite' }, { id: 'INFORME_RENDIMENTO', nome: 'Informe de Rendimento' }]},
            { field: 'useUsuarios', md: 6, xs: 12, multiSelect: true, disabled: !hasPermission(moduleConfigurations, authData) },
          ]}
          defaultFilter={defaultFilter(moduleConfigurations, authData)}
        />
      </Grid>
      <Grid item xs={12} className={classes.root}>
        <Table
          titles={['Mês/Ano Referência', 'Tipo', 'Usuário', 'Criado Por', 'Data Inclusão']}
          headerTitle="Holerites"
          renderRows={renderRows}
          hasRowActions
          onEdit={onEdit}
          onAdd={onAdd}
          hasAdd={adminPermission}
          showView={!adminPermission}
          onView={onEdit}
          showEdit={adminPermission}
          showDelete={adminPermission}
          onDelete={onDelete}
          usePaginationApi
          paginationApi="olerites/filter"
          paginationUrl="olerites"
          filterData={localFilter}
          reload={!reload}
        />
        <Formulario
          open={openAdd}
          onClose={onClose}
        />
        <FormularioEdicao
          open={openEdicao}
          onClose={onClose}
          adminPermission={adminPermission}
          id={id}
        />
      </Grid>
    </Grid>
  );
};

const mapStateToProps = state => ({
  authData: selectorsAuth.getAuth(state),
  moduleConfigurations: selectorsModuleConfiguration.getModuleConfigurations(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ ...actionsOlerite }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Olerite);
